import { TestIdDomain } from 'constants/testIds';

export const FormChangeHistoryTestIds = {
  BUTTON: `${TestIdDomain.FORMS}.change-history-button`,
  DRAWER: `${TestIdDomain.FORMS}.change-history-drawer`,
  OVERRIDE_CHIP: `${TestIdDomain.FORMS}.change-history-override-chip`,
  NOT_EFFECTIVE_CHIP: `${TestIdDomain.FORMS}.change-history-not-effective-chip`,
  TEMPLATE_STATE: `${TestIdDomain.FORMS}.change-history-template-state`,
  TEMPLATE_RETRY_BUTTON: `${TestIdDomain.FORMS}.change-history-template-retry-button`,
  NO_TEMPLATE_VALUE: `${TestIdDomain.FORMS}.change-history-no-template-value`,
  PRISM_CHANGESET: `${TestIdDomain.FORMS}.change-history-prism-changeset`,
  PART_GROUP: `${TestIdDomain.FORMS}.change-history-part-group`,
  PART_GROUP_SUMMARY: `${TestIdDomain.FORMS}.change-history-part-group-summary`,
  PART_ROW: `${TestIdDomain.FORMS}.change-history-part-row`,
  PART_KIND: `${TestIdDomain.FORMS}.change-history-part-kind`,
  PART_NAME: `${TestIdDomain.FORMS}.change-history-part-name`,
  PART_WHERE: `${TestIdDomain.FORMS}.change-history-part-where`,
  PART_CHANGE_CHIP: `${TestIdDomain.FORMS}.change-history-part-change-chip`,
  REIMPORTED_TOTALS: `${TestIdDomain.FORMS}.change-history-reimported-totals`,
  PDF_CHANGESET: `${TestIdDomain.FORMS}.change-history-pdf-changeset`,
  FIELD_MAPPING_TABLE: `${TestIdDomain.FORMS}.change-history-field-mapping-table`,
  HTML_CHANGESET: `${TestIdDomain.FORMS}.change-history-html-changeset`,
  FILE_SIDE: `${TestIdDomain.FORMS}.change-history-file-side`,
  CHECKSUM_COPY: `${TestIdDomain.FORMS}.change-history-checksum-copy`,
  OPEN_FILE_BUTTON: `${TestIdDomain.FORMS}.change-history-open-file-button`,
  FILE_MODAL: `${TestIdDomain.FORMS}.change-history-file-modal`,
  HTML_FRAME: `${TestIdDomain.FORMS}.change-history-html-frame`,
  RAW_JSON: `${TestIdDomain.FORMS}.change-history-raw-json`,
  RAW_JSON_PANE: `${TestIdDomain.FORMS}.change-history-raw-json-pane`,
  RAW_JSON_COPY: `${TestIdDomain.FORMS}.change-history-raw-json-copy`,
  COMPARE_ACTION: `${TestIdDomain.FORMS}.change-history-compare-action`,
  COMPARE_MODAL: `${TestIdDomain.FORMS}.change-history-compare-modal`,
  COMPARE_CONTENT: `${TestIdDomain.FORMS}.change-history-compare-content`,
  COMPARE_STATE: `${TestIdDomain.FORMS}.change-history-compare-state`,
  COMPARE_RETRY_BUTTON: `${TestIdDomain.FORMS}.change-history-compare-retry-button`,
  COMPARE_FIELDS: `${TestIdDomain.FORMS}.change-history-compare-fields`,
  VERSION_PICKER: `${TestIdDomain.FORMS}.change-history-version-picker`,
  VERSION_PICKER_INPUT: `${TestIdDomain.FORMS}.change-history-version-picker-input`,
  VERSION_OPTION: `${TestIdDomain.FORMS}.change-history-version-option`,
  BACK_TO_CHANGE_BUTTON: `${TestIdDomain.FORMS}.change-history-back-to-change-button`,
  PREVIEW_BUTTON: `${TestIdDomain.FORMS}.change-history-preview-button`,
  PREVIEW_MODAL: `${TestIdDomain.FORMS}.change-history-preview-modal`,
  PREVIEW_PANE: `${TestIdDomain.FORMS}.change-history-preview-pane`,
  PREVIEW_STATE: `${TestIdDomain.FORMS}.change-history-preview-state`,
  PREVIEW_RETRY_BUTTON: `${TestIdDomain.FORMS}.change-history-preview-retry-button`,
  PREVIEW_PAGE_BUTTON: `${TestIdDomain.FORMS}.change-history-preview-page-button`,
  PREVIEW_PAGE_MARK_COUNT: `${TestIdDomain.FORMS}.change-history-preview-page-mark-count`,
  PREVIEW_PAGE_MARK: `${TestIdDomain.FORMS}.change-history-preview-page-mark`,
  PREVIEW_MARK_NUMBER: `${TestIdDomain.FORMS}.change-history-preview-mark-number`,
  PREVIEW_CHANGES_PANEL: `${TestIdDomain.FORMS}.change-history-preview-changes-panel`,
  PREVIEW_CHANGES_STATE: `${TestIdDomain.FORMS}.change-history-preview-changes-state`,
  PREVIEW_MARK_ROW: `${TestIdDomain.FORMS}.change-history-preview-mark-row`,
  PREVIEW_OTHER_PAGE_BUTTON: `${TestIdDomain.FORMS}.change-history-preview-other-page-button`,
  PREVIEW_UNPLACED_MARKS: `${TestIdDomain.FORMS}.change-history-preview-unplaced-marks`,
  SAMPLE_DATA_NOTICE: `${TestIdDomain.FORMS}.change-history-sample-data-notice`,
};
